'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-loader-spinner.cjs.production.js')
} else {
  module.exports = require('./react-loader-spinner.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/react-loader-spinner/dist/index.js
// module id = 1556
// module chunks = 0